import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderHomeReviews() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 4,
                        spaceBetween: 50,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >
                <SwiperSlide>
                    <div className="owl-item" style={{ width: '286.5px', marginRight: 10 }}>
                        <div className="testimonial-item">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote">
                                <p>
                                    The learning environment here is excellent. Smart classrooms, well-equipped labs, and experienced teachers make learning interesting and easy. I am proud to be a student of this school.
                                </p>
                            </div>
                            <div className="testimonial-content">
                                <div className="testimonial-author-img">
                                    <img src="assets/school/profile.png" alt />
                                </div>
                                <div className="testimonial-author-info">
                                    <h4>Rahul Singh</h4>
                                    <p>Student</p>
                                </div>
                            </div>
                            <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item" style={{ width: '286.5px', marginRight: 10 }}>
                        <div className="testimonial-item">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote">
                                <p>
                                    I love my school because teachers explain every topic very clearly. They always motivate us to participate in activities, debates, and sports. School life here is joyful and inspiring.
                                </p>
                            </div>
                            <div className="testimonial-content">
                                <div className="testimonial-author-img">
                                    <img src="assets/school/profile.png" alt />
                                </div>
                                <div className="testimonial-author-info">
                                    <h4>Ananya Patel</h4>
                                    <p>Student</p>
                                </div>
                            </div>
                            <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item" style={{ width: '286.5px', marginRight: 10 }}>
                        <div className="testimonial-item">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote">
                                <p>
                                    This school focuses on discipline, values, and quality education. I have learned teamwork, confidence, and leadership skills along with my studies.
                                </p>
                            </div>
                            <br />
                            <div className="testimonial-content">
                                <div className="testimonial-author-img">
                                    <img src="assets/school/profile.png" alt />
                                </div>
                                <div className="testimonial-author-info">
                                    <h4>Aman Verma</h4>
                                    <p>Student</p>
                                </div>
                            </div>
                            <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item" style={{ width: '286.5px', marginRight: 10 }}>
                        <div className="testimonial-item">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote">
                                <p>
                                    Our school provides the best guidance for academics and career planning. Teachers give personal attention and help us improve continuously.
                                </p>
                            </div>
                            <br />
                            <br />
                            <div className="testimonial-content">
                                <div className="testimonial-author-img">
                                    <img src="assets/school/profile.png" alt />
                                </div>
                                <div className="testimonial-author-info">
                                    <h4>Pooja Mishra</h4>
                                    <p>Student</p>
                                </div>
                            </div>
                            <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item" style={{ width: '286.5px', marginRight: 10 }}>
                        <div className="testimonial-item">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote">
                                <p>
                                    The learning environment here is very friendly and encouraging. Teachers explain every topic clearly and help us whenever we face difficulties. I enjoy coming to school every day.
                                </p>
                            </div>
                            <div className="testimonial-content">
                                <div className="testimonial-author-img">
                                    <img src="assets/school/profile.png" alt />
                                </div>
                                <div className="testimonial-author-info">
                                    <h4>Priya Singh</h4>
                                    <p>Student</p>
                                </div>
                            </div>
                            <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                        </div>
                    </div>
                </SwiperSlide>
               
                <SwiperSlide>
                    <div className="owl-item" style={{ width: '286.5px', marginRight: 10 }}>
                        <div className="testimonial-item">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote">
                                <p>
                                    I love my school because the teachers are kind and caring. They treat every student equally and encourage us to participate in debates, cultural programs, and competitions.
                                </p>
                            </div>
                            <br />
                            <div className="testimonial-content">
                                <div className="testimonial-author-img">
                                    <img src="assets/school/profile.png" alt />
                                </div>
                                <div className="testimonial-author-info">
                                    <h4>Anjali Patel</h4>
                                    <p>Student</p>
                                </div>
                            </div>
                            <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </>
    );
}
